import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store'
import VAnimateCss from 'v-animate-css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Loading from 'vue-loading-overlay'
import Loader from '@/components/Loader.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import vueVimeoPlayer from 'vue-vimeo-player'

Vue.use(VueAxios, axios)
Vue.use(VAnimateCss)
Vue.use(Loading)
Vue.use(VueFacebookPixel)
Vue.use(vueVimeoPlayer)
// import VueResource from "vue-resource";

// vue resource (DELETE)
// Vue.use(VueResource);

// router
Vue.use(router)

Vue.config.productionTip = false

const app = new Vue({
  components: {
    Loader
  },
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// Preloader related stuff
app.$store.commit('loadingToggle', true)
let initLoader = app.$loading.show(
  {
    container: app.$store.getters.loadingState ? app.$refs.vueContainer : null,
    canCancel: false,
    backgroundColor: '#000',
    color: '#fff',
    opacity: 1
  },
  {
    default: app.$createElement('Loader')
  }
)

Vue.analytics.fbq.init('903672686676518', {
  em: 'rajgetsitdone@gmail.com'
})

function hideInitLoader() {
  // destroy previous
  if (initLoader) {
    initLoader.hide()
    initLoader = null
  }
}

setTimeout(() => {
  hideInitLoader()
  app.$store.commit('loadingToggle', false)
}, 5500)

let loader = null
function hideLoader() {
  // destroy previous
  if (loader) {
    loader.hide()
    loader = null
  }
}

function showLoader() {
  hideLoader()
  loader = app.$loading.show(
    {
      container: app.$refs.vueContainer,
      canCancel: false,
      backgroundColor: '#000',
      color: '#fff',
      opacity: 1
    },
    {
      default: app.$createElement('Loader')
    }
  )
}
router.beforeResolve((to, from, next) => {
  app.$store.commit('loadingToggle', true)
  showLoader()
  setTimeout(() => {
    next()
  }, 500)
})

router.afterEach(() => {
  setTimeout(() => {
    hideLoader()
    app.$store.commit('loadingToggle', false)
  }, 4000)
})

// iphone disable double tap to zoom
window.addEventListener('touchmove', function(event) {
  event = event.originalEvent || event
  if (event.scale !== 1) {
    event.preventDefault()
  }
}, false)
